import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseButton, LinkButton } from './BaseButton';

const destructiveSecondaryButtonStyle = {
    background: colorSystem.neutral.white,
    color: colorSystem.neutral[7],
    border: `1px solid ${colorSystem.neutral[3]}`,
    '&:hover': {
        background: colorSystem.red[1],
        color: colorSystem.red[7],
        border: `1px solid ${colorSystem.red[3]}`,
    },
    '&:active': {
        background: colorSystem.red[2],
        color: colorSystem.red[7],
        border: `1px solid ${colorSystem.red[3]}`,
    },
    '&:disabled': {
        background: colorSystem.neutral.white,
        color: colorSystem.neutral[5],
        border: `1px solid ${colorSystem.neutral[4]}`,
    },
};

const DestructiveSecondaryButtonHost = styled(BaseButton)(destructiveSecondaryButtonStyle);
const DestructiveSecondaryButtonLinkHost = styled(LinkButton)(destructiveSecondaryButtonStyle);

export const DestructiveSecondaryButton = linkable(DestructiveSecondaryButtonHost, {
    linkHost: DestructiveSecondaryButtonLinkHost,
});
